/**
 * Entry point: styles + boot the app into `#app`. `boot()` (ui/app.ts) wires
 * the store, engine, controller, UI, audition card, WebMCP tool groups and
 * the built-in agent panel; the handle is kept on `window.__bandmateBoot`
 * for debugging (`window.__bandmate` is the test handle).
 */
import './styles/base.css';
import { boot, renderBootError } from './ui/app';

const root = document.querySelector<HTMLElement>('#app');
if (!root) throw new Error('#app not found');

boot(root)
  .then((result) => {
    (window as Window & { __bandmateBoot?: unknown }).__bandmateBoot = result;
  })
  .catch((err) => {
    console.error('[bandmate] boot failed', err);
    renderBootError(root, err);
  });
